<template>
  <mailbox-settings-layout :name="name">
    <el-card class="mailbox-settings-assign-people">
      <template #header>
        <div class="mailbox-settings-assign-people__header">
          <h3>Add/Remove Users</h3>
          <avatar-gallery
            :people="assignedPeople"
            :max-num-avatars="7"
            stack-tightly
          />
        </div>
      </template>
      <entity-membership-manager
        :entity-type="EEntities.MAILBOXES"
        :entity-id="id"
        class="mailbox-settings-assign-people__entity-membership-manager" 
        @memberships-updated="(val) => assignedPeople = val" 
        @entity-name-fetched="(val) => name = val" />
    </el-card>
  </mailbox-settings-layout>
</template>

<script lang="ts">
/* General */
import { defineComponent } from 'vue'
import MailboxSettingsLayout from '@/layouts/mailbox-settings-layout.vue'

/* Mixins */

/* Components */
import EntitySettingsLoading from '@/layouts/entity-settings-loading.vue'

/* Helpers */

/* Data types */
import { IPersonBase } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */

export default defineComponent({
  name: 'MailboxSettingsAssignPeople',

  components: {
    MailboxSettingsLayout,
    EntitySettingsLoading,
  },

  data() {
    return {
      EEntities,
      name: '',
      assignedPeople: [] as IPersonBase[],
    }
  },

  head(): any {
    return {
      title: `Add/Remove User - ${this.name}`,
    }
  },

  computed: {
    id(): number {
      return parseInt(this.$route.params.id, 10)
    },
  },
})
</script>

<style lang="scss">
.mailbox-settings-assign-people {
  overflow: visible;
  &__header {
    display: flex;
    justify-content: space-between;
  }
  padding-bottom: 20px;
  &__entity-membership-manager {
    margin-top: -24px;

    .entity-settings-loading {
      padding-top: 20px;
    }
  }
}
</style>
